import React from 'react';
import CommonSwitch from '@src/new-components/Switch';
import CommonTypography from '@src/new-components/Typography';
import Badge from './Badge';
import { StyledGroupHeader } from './index.style';

// Tiêu đề của nhóm bật tắt được: tên nhóm, nhãn ghi chú, công tắc bên phải.
const GroupHeader = ({ label, badge, enabled, onToggle }) => (
  <StyledGroupHeader>
    <div className="group-header-title">
      <CommonTypography className="config-group-label" variant="body-14-medium">
        {label}
      </CommonTypography>
      {badge && <Badge>{badge}</Badge>}
    </div>
    <CommonSwitch
      variant="small"
      checked={enabled}
      onChange={(event) => onToggle(event.target.checked)}
    />
  </StyledGroupHeader>
);

export default GroupHeader;
